import { Global } from '@emotion/react';
import { forwardRef } from 'react';
import * as views from './Section.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var Section = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var variant = _ref.variant,
      children = _ref.children,
      copyVariant = _ref.copyVariant,
      _ref$sidebarSize = _ref.sidebarSize,
      sidebarSize = _ref$sidebarSize === void 0 ? "large" : _ref$sidebarSize,
      reverse = _ref.reverse,
      id = _ref.id,
      className = _ref.className,
      sticky = _ref.sticky,
      ariaLabel = _ref.ariaLabel;
  return _jsxs(views.Container, {
    sticky: sticky,
    className: className,
    id: id,
    "aria-label": ariaLabel,
    children: [sticky && _jsx(Global, {
      styles: views.RemoveOverflowFromHTML
    }), _jsx(views.Wrapper, {
      ref: ref,
      variant: variant,
      copyVariant: copyVariant,
      sidebarSize: sidebarSize,
      reverse: reverse,
      children: children
    })]
  });
});
export default Section;